import { Navigate, Outlet, useLocation } from "react-router";
import { useSession } from "./session-context";
import { useTenant } from "@/domains/tenant/hooks";
import { AppLoading } from "@/shared/components/app-loading";
import { isSupabaseUserNotFoundError } from "@/shared/lib/supabase-auth-errors";

export function AuthGuardLayout() {
  const location = useLocation();

  const { isAuthenticated, isLoading: isSessionLoading } = useSession();
  const { isLoading: isTenantLoading, error: tenantError } = useTenant();

  const isLoading = isSessionLoading || isTenantLoading;
  const hasInvalidSessionError =
    isSupabaseUserNotFoundError(tenantError) ||
    (tenantError instanceof Error &&
      tenantError.message === "Not authenticated");

  if (isLoading) {
    return <AppLoading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (hasInvalidSessionError) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
